import { GeoLocation } from '../../../shared-core/domain';

export type GeoLocationState = GeoLocation.GeoLocationObject | null;

const initialState: GeoLocationState = null;
export const geoLocationReducer = (state: GeoLocationState = initialState): GeoLocationState => state;
